export default "__VITE_ASSET__RwAtmP$l__"